// data/researchBenefits.js
const researchBenefits = [
  {
    id: 1,
    front_name: 'Elevated Calm and Serenity',
    front_desc:
      'SKY increases “relaxation brain waves” bringing calm and serenity.',
    back_name: 'SKY Increases Calm',
    back_desc: (
      <div>
        Single session of SKY{' '}
        <a
          href="https://pubmed.ncbi.nlm.nih.gov/32669767/"
          target="_blank"
          className="underline"
        >
          increases calm and relaxation brain waves upto 8%.
        </a>{' '}
        <br />
        SKY practitioners also reported a{' '}
        <a
          href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4728954/"
          target="_blank"
          className="underline"
        >
          37% increase in serenity
        </a>{' '}
        in 4 weeks.
      </div>
    ),
    img: '/images/lotus-mono.png',
    bgColor: '#FFF3F8',
    borderColor: '#F5A9C9',
  },
  {
    id: 2,
    front_name: 'Reduced Clinical and Everyday Anxiety',
    front_desc: 'SKY decreases everyday and clinical anxiety.',
    back_name: 'SKY Decreases Anxiety',
    back_desc: (
      <div>
        4 weeks of SKY practice significantly{' '}
        <a
          href="https://pubmed.ncbi.nlm.nih.gov/22346068/"
          target="_blank"
          className="underline"
        >
          dropped clinical anxiety in 41% of patients
        </a>
        —who did not find relief through therapy or medication.
      </div>
    ),
    link: '#',
    img: '/images/arrow-mono.png',
    bgColor: '#FFEFE5',
    borderColor: '#F5B69A',
  },
  {
    id: 3,
    front_name: 'Improved Sleep Quality',
    front_desc: 'SKY increases deep sleep duration',
    back_name: 'SKY increases deep sleep duration',
    back_desc: (
      <div>
        SKY practitioners experienced{' '}
        <a
          href="https://pubmed.ncbi.nlm.nih.gov/32881710/"
          target="_blank"
          className="underline"
        >
          31% reduction in insomnia and excessive daytime sleepiness
        </a>{' '}
        in 8 weeks. They also reported spending{' '}
        <a
          href="https://onlinelibrary.wiley.com/doi/abs/10.1111/j.1479-8425.2006.00233.x"
          target="_blank"
          className="underline"
        >
          3X more time in deep sleep.
        </a>
      </div>
    ),
    img: '/images/clouds-mono.png',
    bgColor: '#EAEEF8',
    borderColor: '#BDC6F8',
  },
  {
    id: 4,
    front_name: 'Reduced Stress and Pain',
    front_desc: 'SKY increases stress resilience and decreases stress hormone.',
    back_name: 'SKY Reduces Stress',
    back_desc: (
      <div>
        <a
          href="https://pubmed.ncbi.nlm.nih.gov/16740317/"
          target="_blank"
          className="underline"
        >
          SKY reduced stress hormone cortisol up to 57% in 2 weeks,
        </a>{' '}
        and pain perception by 20%. SKY practitioners are{' '}
        <a
          href="https://www.tandfonline.com/doi/abs/10.1080/07448481.2020.1781867?journalCode=vach20"
          target="_blank"
          className="underline"
        >
          more stress resilient with less flight/fight response.
        </a>
      </div>
    ),
    img: '/images/smile-mono.png',
    bgColor: '#FFF5CD',
    borderColor: '#FFC478',
  },
  {
    id: 5,
    front_name: 'Improved Emotional Health',
    front_desc: 'SKY boosts emotional stability.',
    back_name: 'SKY Enhances Emotional Wellbeing',
    back_desc: (
      <div>
        SKY enhanced{' '}
        <a
          href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4728954/"
          target="_blank"
          className="underline"
        >
          emotional control
        </a>{' '}
        in 4 weeks. It also improved the{' '}
        <a
          href="https://pubmed.ncbi.nlm.nih.gov/32669767/"
          target="_blank"
          className="underline"
        >
          brain hemispheres coordination
        </a>{' '}
        allowing sustained{' '}
        <a
          href="https://psycnet.apa.org/record/2011-06706-005?doi=1"
          target="_blank"
          className="underline"
        >
          emotional stability.
        </a>
      </div>
    ),
    img: '/images/heart-mono.png',
    bgColor: '#F7FFE7',
    borderColor: '#C0DB88',
  },
  {
    id: 6,
    front_name: 'Improved Social Connection',
    front_desc:
      'SKY practitioners show  improved ability to connect with others.',
    back_name: 'SKY Improves Social Connection',
    back_desc: (
      <div>
        SKY practitioners enjoyed a 25%{' '}
        <a
          href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4728954/"
          target="_blank"
          className="underline"
        >
          increase in social connectedness
        </a>
        —ability to comfortably connect with others—in 4 weeks.
      </div>
    ),
    img: '/images/globe-mono.png',
    bgColor: '#ECFBFF',
    borderColor: '#9AE3F3',
  },
  {
    id: 7,
    front_name: 'Increased Focus and Cognition',
    front_desc:
      'SKY improves brain functioning, increasing focus and cognition.',
    back_name: 'SKY Increases Focus',
    back_desc: (
      <div>
        Multiple studies show SKY{' '}
        <a
          href="https://pubmed.ncbi.nlm.nih.gov/32669767/"
          target="_blank"
          className="underline"
        >
          improved brain activity
        </a>{' '}
        leading to{' '}
        <a
          href="https://pubmed.ncbi.nlm.nih.gov/15255618/"
          target="_blank"
          className="underline"
        >
          enhanced mental awareness
        </a>
        ,{' '}
        <a
          href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3573542/"
          target="_blank"
          className="underline"
        >
          focus
        </a>{' '}
        ,
        <a
          href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6937876/"
          target="_blank"
          className="underline"
        >
          concentration
        </a>{' '}
        and{' '}
        <a
          href="https://scholar.google.com/scholar_lookup?title=Sudarshan%20Kriya%3A%20a%20quantitative%20analysis&publication_year=2002&author=M.%20Bhatia"
          target="_blank"
          className="underline"
        >
          efficient information processing
        </a>
        .
      </div>
    ),
    link: '#',
    img: '/images/focus-mono.png',
    bgColor: '#E8F2FF',
    borderColor: '#A3CBFB',
  },
  {
    id: 8,
    front_name: 'Reduced Everyday Blues and Depression',
    front_desc: 'SKY reduces everyday blues and clinical depression.',
    back_name: 'SKY Reduces Depression',
    back_desc: (
      <div>
        Regular practice of SKY reduces depression in 15 days(
        <a
          href="https://pubmed.ncbi.nlm.nih.gov/28285240/"
          target="_blank"
          className="underline"
        >
          9
        </a>
        ,{' '}
        <a
          href="https://pubmed.ncbi.nlm.nih.gov/26142611/"
          target="_blank"
          className="underline"
        >
          10
        </a>
        ,{' '}
        <a
          href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2231388/"
          target="_blank"
          className="underline"
        >
          11
        </a>
        ).{' '}
        <a
          href="https://pubmed.ncbi.nlm.nih.gov/27898207/"
          target="_blank"
          className="underline"
        >
          SKY significantly lowered depression
        </a>{' '}
        in individuals unresponsive to antidepressants.
      </div>
    ),
    img: '/images/sun-mono.png',
    bgColor: '#FFF3DF',
    borderColor: '#FEB645',
  },
];
export default researchBenefits;
